module.exports = __webpack_public_path__ + "img/Notification.fcfe777a.svg";